export default __webpack_public_path__ + "static/media/avatar-default.e62db0b4.svg";